global.__litium = global.__litium || {};
window.__litium.themeName = 'vincent';
global.__litium.themeName = 'vincent';

require('./app.js');
